import React, { useState, useEffect, useContext, useCallback } from 'react';

import './CharsheetDM.css'

import { UserDataContext } from "../../App.js";

import FlexiGrid2 from '../common/Flexigrid2/Flexigrid2.js';

import LoadSaveButton from '../CharsheetMobile/MobileLoadSaveButton.js';
import Spellbook from '../Spell/Spellbook.jsx'
import CharNameMobile from '../CharNameMobile.js'

import unflatten from '../../components/Charsheet0/helpers/unflatten.js';
import { toggleEdit } from '../../helpers/toggleEdit.js'
import getAllowedClasses from '../../helpers/getAllowedClasses.js';

import sample_data_flat from '../../components/Charsheet0/helpers/sample_data_flat.js'


// ----------------------------------------------------------------------------------
//                         Description
//
//     CharsheetDM is intended as the main html page for mobile
//
//     It will have a mobile header, a character section, and a details section
//
//     flatten.js has the text field names
//
//     (c) DXA Development 2024
// ----------------------------------------------------------------------------------

function CharsheetDM(props) {


    // ------------ parameters ---------------
    let startData = sample_data_flat
    const INITIAL_MOBILE_SCROLL = 0; // 262;

    // ------ inherited state variables ------
    const [userData, setUserData] = useContext(UserDataContext);
    const [ tempCharData, setTempCharData ] = props.tempCharDataArray;
    const [ activeView, setActiveView ] = props.activeViewArray;

    const globalState = props.state;  

    var currentChar = props.state[0];
    var setChar = props.state[1];

    const [ currentSpell, setCurrentSpell] = props.state[5]
    const [ currentSpellData, setCurrentSpellData ] = props.state[6];

    const spellCheckArray = props.spellCheckArray;

    console.log('CHARSHEET MOBILE:', currentChar)

    const data = props.data;
    const setData = props.setdata;
    var spellUpdaters = props.spellUpdaters;
    spellUpdaters = [setCurrentSpell, setCurrentSpellData]

    // charID is used to ID the main div, which will be id="{charID}-div"
    const thisCharID = props.charID || '0'

    // -------- local state variables --------
    
    var [ charImage, setCharImage ] = useState( process.env.PUBLIC_URL + `/img/char/${userData.currentChar}/` + currentChar + '.jpg' );
    const [ editing, setEditing ] = useState(false);
    const [ allowedClasses, setAllowedClasses] = useState(['Fighter','Cleric', 'Magic-User', 'Thief'])
    const [ allowedRaces, setAllowedRaces] = useState(['Human','Elf', 'Half-Elf', 'Dwarf','Halfling','Gnome','Half-Orc'])
    // const [ activeComponent, setActiveComponent ] = useState('charsleet')

    const [ firstLoad, setFirstLoad ] = useState(true);
    const [ loadedChar, setLoadedChar ] = useState(currentChar);
    const [ isDirty, setIsDirty ] = useState(false);

    const handleDataChange = useCallback((newData) => {
        setData(newData);
        setIsDirty(true);
    }, [setData]);


    // ------------- event handlers ---------------

    // what happens when you click on a Spell Button (Spell1, ...)     
const handleSpellButtonClick = useCallback(() => {
  setEditing((prevEditing) => {
        console.log('Current tempCharData:', tempCharData); // Debugging log
        toggleEdit({
            editing: prevEditing,
            setEditing,
            tempCharData,
            setTempCharData,
            setData,
            data,
        });

        return !prevEditing;
  });
}, [tempCharData, setEditing, setTempCharData, setData, data]);


const validLevels = ['1','2','3','4','5','6','7','8','9','10','11','12']

const checkStatChanges = (newData) => {
    console.log('newData received:', newData);
        toggleEdit({ editing, setEditing, tempCharData, setTempCharData, setData, data: newData},'true')
    }


    // ------------- useEffects ---------------

    useEffect( () => {

        async function RefreshCharacter () {  

            console.log('CharsheetDM UPDATE ', data )

            setLoadedChar( currentChar );

            console.log('mobile data', tempCharData )
            
        }

        RefreshCharacter();

        const classList = getAllowedClasses(data)
        console.log('allowed classes: ', classList)
        setAllowedClasses(classList)

        if (! editing ) { setTempCharData(unflatten(data))}       

    }, [ data, currentChar, userData.currentCampaign ]) ; //useEffect



    // ---------- define the grid for this layout ----------

    const spellOptions = {'spellUpdaters': spellUpdaters, 'handleClick': handleSpellButtonClick, draggable: true }

    const StatStart = 8;
    const ACyStart = 16;
    const WeapyStart = 22;
    const SavyStart = 28;
    
    const PotStart = 32;
    const MagStart = PotStart+7;
    const OthStart = 45;
    const FollowerStart = 53;
    const SpellStart = 66;

    let Start = [];
    for (let i = 1; i <= 11; i++) {
        Start[i] = 3*i -1
    
    }
    // most common cell - implemented as input boxes
    const cells_layout_main = { 
      
  };



    // ---------- HTML CELLS ----------
const cells_html = [];

for (let i = 1; i <= 10; i++) {
    const start = Start[i];
    cells_html.push(
        {'name': `myWeap${i}`, 'coords': [1, 6, start, start+1], 'type': 'input', 'options': { class: "mobile-DM"} },
        {'name': `myMag${i}`, 'coords': [6, 7, start, start+1], 'type': 'input', 'options': { class: "mobile-DM"} },
        {'name': `myWdb${i}`, 'coords': [7, 9, start, start+1], 'type': 'input', 'options': { class: "mobile-DM"} },
        {'name': `myWth${i}`, 'coords': [1, 2, start+1, start+3], 'type': 'input', 'options': { class: "mobile-DM"} },
        {'name': `myWdmg${i}`, 'coords': [2, 6, start+1, start+3], 'type': 'input', 'options': { class: "mobile-DM"} },
        {'name': `myArm${i}`, 'coords': [7, 9, start+1, start+3], 'type': 'input', 'options': { class: "mobile-DM"} },
        {'name': `myAb${i}`, 'coords': [6, 7, start+1, start+3], 'type': 'input', 'options': { class: "mobile-DM"} }
    );
}
console.log('cellsHTML ________________', cells_html)
    // define the box structure
    const boxez = () => {
        
        const boxes_main = {  }

        var boxes_temp =  { }

        for (let i = 1; i <= 10; i++) {
            boxes_temp[`boxMonst${i}`] = [1, 9, Start[i], Start[i+1]];
        }
        
        return boxes_temp
    }

        
// ---------- RETURN JSX ----------

    return (
        <>
        <div id="charsheet-scroll-DM">
        {activeView === 'charsheet' ?
            <>
              <div id="charsheet-full" className="CharsheetDM">

                <FlexiGrid2
                      rowSize = '8px'
                      colSize = '36px'
                      id = {thisCharID+'-grid-full'}
                      classRoot = 'cf'
                      cells = { cells_layout_main }
                      cellsHTML = { cells_html }
                      data = { data }
                      onDataChange = { handleDataChange }
                      boxes = { boxez() }
                      globalState = { props.state}
                />

                <LoadSaveButton className='no-printy loadbutton-mobile' state={[data, setData, currentChar, setChar ]} spellCheckArray={spellCheckArray} isDirty={isDirty} setIsDirty={setIsDirty}/>

              </div>
              <div id="footer"><b>Advanced Dungeon Master</b><br />by DXA Development</div>    
            </>
        :
            <Spellbook state={globalState} {...props} />
        }
        </div>
        </>
    )

    };  // end of function

    export default CharsheetDM

/* Example usage (from Charsheet05)
    <CharsheetDM state={props.state} data={char1data} setdata={setChar1Data} charID='char1' />
    <CharsheetDM state={props.state} data={char2data} setdata={setChar2Data} charID='char2' />
*/